import { render, staticRenderFns } from "./InfoVinculacion.vue?vue&type=template&id=ee544dd4"
import script from "./InfoVinculacion.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoVinculacion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports